"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _semanticUiReact = require("semantic-ui-react");

var _reactGa = _interopRequireDefault(require("react-ga"));

var _Completion = _interopRequireDefault(require("./Completion"));

var _FishermanLogo = _interopRequireDefault(require("./FishermanLogo"));

var _urls = require("../../../utils/urls");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var RequestEditModal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(RequestEditModal, _React$Component);

  var _super = _createSuper(RequestEditModal);

  function RequestEditModal() {
    var _this;

    (0, _classCallCheck2["default"])(this, RequestEditModal);
    _this = _super.call(this);
    _this.state = {
      currentRequestMessage: '',
      requestInProgress: true,
      name: '',
      email: '',
      phone: '',
      errorMessage: ''
    };
    _this.handleRequestChange = _this.handleRequestChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.submitRequest = _this.submitRequest.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFieldChange = _this.handleFieldChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clickToPublish = _this.clickToPublish.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setErrorMessage = _this.setErrorMessage.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(RequestEditModal, [{
    key: "setErrorMessage",
    value: function setErrorMessage(message) {
      var _this2 = this;

      var stop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.setState({
        errorMessage: message
      });

      if (!stop) {
        setTimeout(function () {
          return _this2.setErrorMessage('', true);
        }, 3000);
      }
    }
  }, {
    key: "validateInput",
    value: function validateInput() {
      var _this$state = this.state,
          name = _this$state.name,
          email = _this$state.email,
          phone = _this$state.phone;
      if (name.length === 0) return 'Please enter your name';
      if (email.length === 0) return 'Please enter your email';
      if (phone.length === 0) return 'Please enter your phone number';
      return true;
    }
  }, {
    key: "handleFieldChange",
    value: function handleFieldChange(e, _ref) {
      var value = _ref.value,
          name = _ref.name;
      this.setState((0, _defineProperty2["default"])({}, name, value));
    }
  }, {
    key: "handleRequestChange",
    value: function handleRequestChange(e, _ref2) {
      var value = _ref2.value;
      this.setState({
        currentRequestMessage: value
      });
    }
  }, {
    key: "submitRequest",
    value: function submitRequest() {
      var _this3 = this;

      var _this$state2 = this.state,
          currentRequestMessage = _this$state2.currentRequestMessage,
          email = _this$state2.email,
          phone = _this$state2.phone,
          personalName = _this$state2.name;
      var validation = this.validateInput();

      if (validation === true) {
        var business = this.props.business;
        var businessType = business.type,
            businessId = business.id;
        var url = (0, _urls.getBusinessEmailServiceURL)(businessType, businessId);

        _axios["default"].post(url, {
          contact_name: personalName,
          contact_email: email,
          contact_phone: phone,
          message: currentRequestMessage,
          email_type: 'publish_banner_request_edit'
        }).then(function () {
          _this3.setState({
            requestInProgress: false
          });
        });
      } else {
        this.setErrorMessage(validation);
      }
    }
  }, {
    key: "clickToPublish",
    value: function clickToPublish() {
      var _this$props = this.props,
          handlePublishOpen = _this$props.handlePublishOpen,
          handleRequestEditClose = _this$props.handleRequestEditClose;
      handlePublishOpen();
      handleRequestEditClose();
    }
  }, {
    key: "logEvent",
    value: function logEvent(step) {
      var business = this.props.business;

      _reactGa["default"].event({
        category: 'Checkout',
        action: "Step ".concat(step),
        label: business.name
      });
    }
  }, {
    key: "renderRequestEdit",
    value: function renderRequestEdit() {
      var _this4 = this;

      var handleRequestEditClose = this.props.handleRequestEditClose;
      var _this$state3 = this.state,
          email = _this$state3.email,
          name = _this$state3.name,
          phone = _this$state3.phone,
          errorMessage = _this$state3.errorMessage;
      this.logEvent('Request Edit');
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, {
        className: "modal-header"
      }, "Request an edit"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-content modal-body"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "body-text blue-color"
      }, "Let us know if you have a specific request for an update to this website and we\u2019ll respond within 48 hours. Note that once you publish your site, you can easily edit content, color, and font directly using the Fisherman Dashboard. \xA0", /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "publish-now-from-request-button",
        className: "publish-now-from-request-button body-text blue-color",
        onClick: this.clickToPublish
      }, "Click here"), "\xA0to publish now."), /*#__PURE__*/_react["default"].createElement("h3", {
        className: "header-text blue-color extra-margin"
      }, "Describe your request here"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "request-edit-fields"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: name,
        placeholder: "Name",
        name: "name",
        onChange: this.handleFieldChange
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: email,
        placeholder: "Email",
        name: "email",
        onChange: this.handleFieldChange
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        value: phone,
        placeholder: "Phone",
        name: "phone",
        onChange: this.handleFieldChange
      })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.TextArea, {
        id: "request-text-area",
        type: "text",
        placeholder: "Edit Request",
        className: "request-input",
        onChange: this.handleRequestChange
      }), errorMessage && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: 'red',
          textAlign: 'center'
        }
      }, errorMessage), /*#__PURE__*/_react["default"].createElement("div", {
        className: "centered-content extra-margin"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "back-button-request-edit",
        className: "back-edit-request-button blue-color body-text",
        onClick: handleRequestEditClose
      }, "Back"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        id: "submit-edit-request-button",
        className: "submit-edit-request-button body-text green-background-color",
        onClick: function onClick() {
          return _this4.submitRequest();
        }
      }, "Submit"))));
    }
  }, {
    key: "renderCompletion",
    value: function renderCompletion() {
      this.logEvent('Request Edit Completion');
      return /*#__PURE__*/_react["default"].createElement(_Completion["default"], {
        title: "Submission Complete",
        description: "We will text you a link to your edited site within 48 hours."
      });
    }
  }, {
    key: "render",
    value: function render() {
      var requestInProgress = this.state.requestInProgress;
      var _this$props2 = this.props,
          showRequestEditModal = _this$props2.showRequestEditModal,
          handleRequestOpen = _this$props2.handleRequestOpen,
          handleRequestClose = _this$props2.handleRequestClose;
      var modalBody = requestInProgress ? this.renderRequestEdit() : this.renderCompletion();
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal, {
        id: "request-edit-modal",
        trigger: /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
          id: "request-edit-button",
          className: "payment-request-button"
        }, "Request an edit"),
        className: "modal-container",
        dimmer: "inverted",
        open: showRequestEditModal,
        onOpen: handleRequestOpen,
        onClose: handleRequestClose,
        closeIcon: /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
          id: "inside-close-icon",
          className: "inside-close-icon",
          icon: true
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
          name: "close"
        }))
      }, /*#__PURE__*/_react["default"].createElement(_FishermanLogo["default"], null), modalBody);
    }
  }]);
  return RequestEditModal;
}(_react["default"].Component);

exports["default"] = RequestEditModal;